import React from 'react'
import img from "../assets/rsa.png";
import saket from "../assets/saket.jpg";
import durga from "../assets/durga.jpg";
import yaswanth from "../assets/yaswanth.jpeg";
import TEJADP from "../assets/TEJADP.jpg";
import pavan from "../assets/pavan.jpg";

function Authors() {
  return (
    
    <div class="mb-20 text-gray-700 dark:bg-[#0a192f]">
      <div className='grid md:grid-cols-5 gap-10 m-5 p-10 items-center justify-center '>
        <div className='rounded-md border-double border p-5 border-sky-900 dark:border-teal-500'>
        <figure class="relative max-w-sm transition-all duration-300 cursor-pointer filter dark:grayscale dark:hover:grayscale-0  ">
    <img class="rounded-lg h-[20rem] " src={TEJADP} alt="image description"/>
    </figure>
    <hr className='mt-5 text-sky-900' />
    <p className='mt-3 text-center text-1.5xl dark:text-teal-500'>Tejeswara Murthy Palwadi</p>
        </div>
     
        <div className='rounded-md border-double border p-5 border-sky-900 dark:border-teal-500'>
        <figure class="relative max-w-sm transition-all duration-300 cursor-pointer filter dark:grayscale dark:hover:grayscale-0  ">
    <img class="rounded-lg h-[20rem] " src={saket} alt="image description"/>
    </figure>
    <hr className='mt-5 text-sky-900' />
    <p className='mt-3 text-center text-1.5xl dark:text-teal-500'>Saket Palarapu</p>
        </div>

         

        <div className='rounded-md border-double border p-5 border-sky-900 dark:border-teal-500'>
        <figure class="relative max-w-sm transition-all duration-300 cursor-pointer filter dark:grayscale dark:hover:grayscale-0  ">
    <img class="rounded-lg h-[20rem] " src={pavan} alt="image description"/>
    </figure>
    <hr className='mt-5 text-sky-900' />
    <p className='mt-3 text-center text-1.5xl dark:text-teal-500'>Guda Pavaneeshwar Reddy</p>
        </div>

        <div className='rounded-md border-double border p-5 border-sky-900 dark:border-teal-500'>
        <figure class="relative max-w-sm transition-all duration-300 cursor-pointer filter dark:grayscale dark:hover:grayscale-0  ">
    <img class="rounded-lg h-[20rem] " src={durga} alt="image description"/>
    </figure>
    <hr className='mt-5 text-sky-900' />
    <p className='mt-3 text-center text-1.5xl dark:text-teal-500'>Vibudi Durga Vara Prasad</p>
        </div>

        <div className='rounded-md border-double border p-5 border-sky-900 dark:border-teal-500'>
        <figure class="relative max-w-sm transition-all duration-300 cursor-pointer filter dark:grayscale dark:hover:grayscale-0  ">
    <img class="rounded-lg h-[20rem] " src={yaswanth} alt="image description"/>
    </figure>
    <hr className='mt-5 text-sky-900' />
    <p className='mt-3 text-center text-1.5xl dark:text-teal-500'>Sollu Yaswanth Sai</p>
        </div>
      
      </div>
   
  </div>
  
)
}

export default Authors